import { render, staticRenderFns } from "./EditMiniprogram.vue?vue&type=template&id=1f7aac8a&scoped=true&"
import script from "./EditMiniprogram.vue?vue&type=script&lang=js&"
export * from "./EditMiniprogram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7aac8a",
  null
  
)

export default component.exports